import { useTranslation } from "react-i18next";

const OrderState = ({ order, className }) => {
  let cssClass = "bg-gray-400 text-white";
  const { t } = useTranslation();

  switch (order.state) {
    case "awaiting":
      cssClass = "bg-bioport-orange text-white";
      break;
    case "canceled":
      cssClass = "bg-red-500 text-white";
      break;
    case "validated":
      cssClass = "bg-green-600 text-white";
      break;
    case "ready":
      cssClass = "bg-bioport-blue-dark text-white";
      break;
    case "shipped":
      cssClass = "bg-purple-600 text-white";
      break;
  }

  return (
    <span className={`rounded ${cssClass} ${className} whitespace-nowrap`}>
      {t("settings.orders.state." + order.state)}
    </span>
  );
};

export default OrderState;
